
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

export default class FormError extends Vue {
  @Prop({ type: Array, required: true }) errors: { message: string }[] = [];
}
